// extracted by mini-css-extract-plugin
var _1 = "AttachmentMention-module__content--vgnka";
var _2 = "AttachmentMention-module__popOverContainer--ZbIaq";
export { _1 as "content", _2 as "popOverContainer" }
